import { T } from "@repo/transifex";
import {
  useCollectOrderLines,
  useCollectSuccessHandler
} from "~/api/collect/hooks/use-collect-order-lines";
import { type TransformedCollectOrder } from "~/api/collect/hooks/use-get-collect-order";
import { Button } from "~/components";
import { useOrderLinesToCollect } from "~/providers/store/collect/hooks";
import { parseOrderLinesToCollect } from "~/utils/collect/parse-order-lines-to-collect";

type CollectConfirmButtonProps = {
  order: TransformedCollectOrder;
  childId: string;
};

export const CollectConfirmButton = ({
  order,
  childId
}: CollectConfirmButtonProps) => {
  const { mutate: collectOrderLines, isPending: isCollecting } =
    useCollectOrderLines();
  const handleCollectSuccess = useCollectSuccessHandler();

  const orderLinesToCollect = useOrderLinesToCollect();

  const handleSubmit = () => {
    const orderLines = parseOrderLinesToCollect({
      orderLineToCollectIds: orderLinesToCollect,
      activeOrderLines: order.activeOrderLines
    });

    collectOrderLines(
      {
        childId,
        orderLines
      },
      {
        onSuccess: () => {
          handleCollectSuccess({
            collectedOrderLines: orderLines.length,
            isFullyCollected:
              order.activeOrderLines.length === orderLinesToCollect.length,
            forceRedirect: true
          });
        }
      }
    );
  };

  return (
    <Button
      className="rounded-none"
      disabled={isCollecting || orderLinesToCollect.length === 0}
      onClick={handleSubmit}
      size="large"
      variant="primary"
    >
      <T _str="Confirm collection" />
    </Button>
  );
};
